<template>
  <section class="container">
    <div v-for="(faq, index) in faqs" :key="index" class="faq">
      <h3
        class="question"
        @click="toggleAnswer(index)"
        v-html="`#${index + 1} - ${faq.question}`"
      />

      <div v-if="isTextAnswer(faq)" class="answer">
        <div v-show="faq.visible" class="text" v-html="faq.answer" />
      </div>

      <div v-if="isYouTubeAnswer(faq)" class="answer">
        <div v-show="faq.visible" class="video">
          <iframe
            :src="`https://www.youtube.com/embed/${faq.youtube_key}`"
            width="100%"
            height="720"
            frameborder="0"
            allowfullscreen
            sandbox="allow-scripts allow-same-origin"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FAQ',

  props: {
    items: { type: Array, required: true }
  },

  data() {
    return {
      faqs: this.items
    };
  },

  methods: {
    isTextAnswer(faq) {
      return faq.type === 'text';
    },

    isYouTubeAnswer(faq) {
      return faq.type === 'youtube';
    },

    toggleAnswer(index) {
      this.faqs[index].visible = !this.faqs[index].visible;
    }
  }
};
</script>
